/**
 * A dataservice that provides access to tickets
 */
export class TicketService {
  public ticketResource: ng.resource.IResourceClass<ng.resource.IResource<InterACT.Interfaces.Tickets.TicketResponse | InterACT.Interfaces.Tickets.TicketsResponse>>;

  constructor($resource) {
    this.ticketResource = $resource('api/tickets/:ticketId');
  }

  public getTickets(searchText: string) {
    const options: any = {};

    if (angular.isDefined(searchText)) {
      options.q = searchText;
    }

    return this.ticketResource.get(options).$promise.then((response: InterACT.Interfaces.Tickets.TicketsResponse) => {
      return response.tickets;
    });
  }

  public getTicket(ticketId: string) {
    return this.ticketResource.get({ ticketId: ticketId }).$promise.then((response: InterACT.Interfaces.Tickets.TicketResponse) => {
      return response.ticket;
    });
  }
}